import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";

import { BSModal } from "../../../../common";

class ResetInvoiceStatusButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = { showModal: false };

    this.close = this.close.bind(this);
    this.confirmOperation = this.confirmOperation.bind(this);
    this.confirmed = this.confirmed.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  confirmOperation() {
    this.setState({ showModal: true });
  }

  confirmed() {
    this.setState({ showModal: false });
    this.props.callback();
  }
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }
  render() {
    const { invoiceNumber } = this.props;

    return (
      <span className="dataTable-action-button">
        <span
          className="dataTable-action-button action-icon icon-undo"
          onClick={this.confirmOperation}
        >
          {this.props.label}
        </span>
        <BSModal
          show={this.state.showModal}
          title={
            <FormattedMessage id="invoices.resetButton.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          actions={[
            {
              id: 1,
              text: <FormattedMessage id="common.confirm" />,
              action: this.confirmed,
            },
          ]}
          onClose={this.close}
        >
          <div>
            <FormattedMessage
              id="invoices.resetButton.message"
              values={{ invoiceNumber }}
            />
          </div>
        </BSModal>
      </span>
    );
  }
}

ResetInvoiceStatusButton.propTypes = {
  callback: PropTypes.func.isRequired,
  invoiceNumber: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ReactTimeout(ResetInvoiceStatusButton);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/ResetInvoiceStatusButton.js